module.exports = __webpack_public_path__ + "13abbec8b5182f477067bf125d8b1d23.svg";